import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * /discover/global/:collectionId — a global collection's address on
 * Discover. It IS the collection's home (plan §4.7): a global collection is
 * published in place, so there is no second page to keep in step with it.
 */
export default function GlobalCollectionRedirect() {
	const { collectionId } = useParams();
	return <Navigate to={`/collections/${collectionId}/`} replace />;
}
